import Icon, { type IconName, type IconSize } from 'components/Icon';
import Link from 'components/Link';
import Text, { type Tags } from 'components/Text';
import type { Field } from 'models/sitecore';
import { cnm } from 'utils/classNames';

type Size = 'lg' | 'md' | 'sm' | 'xs';

interface BaseProps {
	className?: string;
	href: string;
	icon: IconName;
	iconPosition?: 'left' | 'right';
	rel?: string;
	size?: Size;
	target?: string;
}
interface WithTextProps extends BaseProps {
	field?: never;
	text: string;
}
interface WithFieldProps extends BaseProps {
	field: Field<string>;
	text?: never;
}

type Props = WithTextProps | WithFieldProps;

const ICON_SIZES: Record<Size, IconSize> = {
	xs: 20,
	sm: 20,
	md: 24,
	lg: 24,
};
const GAPS: Record<Size, string> = {
	xs: 'gap-2',
	sm: 'gap-2',
	md: 'gap-2',
	lg: 'gap-3',
};
const TEXT_STYLES: Record<Size, Tags> = {
	xs: 'pXSmall',
	sm: 'pSmall',
	md: 'p',
	lg: 'p',
};

export default function IconLink({
	className,
	field,
	href,
	icon,
	iconPosition = 'left',
	rel,
	size = 'sm',
	target,
	text,
}: Props) {
	return (
		<Link
			href={href}
			target={target}
			rel={rel}
			className={cnm(
				'group inline-flex items-center align-top',
				GAPS[size],
				className,
			)}
		>
			{iconPosition === 'left' && <Icon name={icon} size={ICON_SIZES[size]} />}
			<Text
				as="span"
				styleAs={TEXT_STYLES[size]}
				className="underline group-hover:underline-strong"
				field={field}
				text={text}
			/>
			{iconPosition === 'right' && <Icon name={icon} size={ICON_SIZES[size]} />}
		</Link>
	);
}
IconLink.displayName = 'IconLink';
